export const colors = {
    primaryColor: '#7c9bad',
    lightBgLayoutColor: '#ffffff',
    darkBgLayoutColor: '#050505',
    lightBgContainerColor: '#F0F3F5',
    darkBgContainerColor: '#1f1f1f',
    lightTextColor: '#021728',
    darkTextColor: '#e1e6eb',
    lightHeaderColor: '#ffffff',
    darkHeaderColor: '#1f1f1f',
    lightSiderColor: '#3e4a5a',
    darkSiderColor: '#1f1f1f',
    lightTriggerBgColor: '#7c9bad',
    darkTriggerBgColor: '#383838',
    lightMenuBgColor: '#DDE8EC',
    darkMenuBgColor: '#1f1f1f',
    lightElevatedBgColor: '#ffffff',
    darkElevatedBgColor: '#383838',
    lightMenuItemColor: '#021728',
    darkMenuItemColor: '#e1e6eb',
    lightMenuItemHoverColor: '#021728',
    darkMenuItemHoverColor: '#e1e6eb',
    lightMenuItemSelectedColor: '#021728',
    darkMenuItemSelectedColor: '#e1e6eb',
    lightMenuItemSelectedBgColor: '#c0d1da',
    darkMenuItemSelectedBgColor: '#383838',
    lightColorHighlight: '#DDE8EC',
    darkColorHighlight: '#383838',
    lightSubmenuItemBgColor: '#F0F2F4',
    darkSubmenuItemBgColor: '#282828',
    lightTableHeaderBgColor: '#FEFEFF',
    darkTableHeaderBgColor: '#282828',
    lightTableBorderColor: '#E8ECEF',
    darkTableBorderColor: '#302F30',
    lightColorSplit: '#E8ECEF',
    darkColorSplit: '#302F30',
    lightColorBorderSecondary: '#E8ECEF',
    darkColorBorderSecondary: '#302F30',
    checkboxBorderColor: '#707070',
    lightTextLabelColor: '#707070',
    darkTextLabelColor: '#707070'
}
